import {
  type ScanUiContext,
  type ScanUiContextEntry,
  type ScanUiContextRegistry,
} from '../types/scanContext.type';

const CLOSED_UI_CONTEXT: ScanUiContext = { openDrawer: false };

/**
 * Tracks which drawers are currently open so scan events can be enriched with UI
 * context. Drawer open state lives in local component state, so each drawer
 * publishes itself here while mounted and open.
 */
export const createScanUiContextRegistry = (): ScanUiContextRegistry => {
  const entries = new Map<symbol, ScanUiContextEntry>();

  return {
    register: (entry) => {
      const token = Symbol('scanUiContextEntry');
      entries.set(token, entry);

      return {
        release: () => {
          entries.delete(token);
        },
        update: (nextEntry) => {
          if (entries.has(token)) entries.set(token, nextEntry);
        },
      };
    },
    reset: () => entries.clear(),
    snapshot: () => {
      const topmost = Array.from(entries.values()).pop();

      if (!topmost) return { ...CLOSED_UI_CONTEXT };

      return {
        openDrawer: true,
        openDrawerName: topmost.drawerName,
        ...(topmost.selectedOrderObjectId && {
          selectedOrderObjectId: topmost.selectedOrderObjectId,
        }),
        ...(topmost.selectedShipmentId && { selectedShipmentId: topmost.selectedShipmentId }),
        ...(topmost.selectedTransactionObjectId && {
          selectedTransactionObjectId: topmost.selectedTransactionObjectId,
        }),
      };
    },
  };
};
